import { NgModule, ModuleWithProviders } from '@angular/core';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownComponent } from './components/dropdown/dropdown.component';
// import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ValueHeaderComponent } from './components/value-header/value-header.component';
import { SearchPipe } from './pipes/search.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { ValueFooterComponent } from './components/value-footer/value-footer.component';
import { DeleteConfirmationComponent } from './components/delete-confirmation/delete-confirmation.component';
import { SelectDropdownRequiredValidatorDirective } from './directives/select-dropdown-required-validator';
import { DotsLoaderComponent } from './components/dots-loader/dots-loader.component';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { SearchComponent } from './components/search/search.component';
import { ShowMoreComponent } from './components/show-more/show-more.component';
import { MultiselectDropdownComponentComponent } from './components/multiselect-dropdown/multiselect-dropdown-component.component';
import { SelectedGapsComponent } from './components/selected-gaps/selected-gaps.component';
import { ProblemSolvingAttitudeComponent } from './components/problem-solving-attitude/problem-solving-attitude.component';
import { GenerateReportComponent } from './components/generate-report/generate-report.component';

@NgModule({
    imports: [
        NgbModule.forRoot(),
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule
    ],
    declarations: [
        DropdownComponent,
        ValueHeaderComponent,
        SearchPipe,
        SortPipe,
        ValueFooterComponent,
        DeleteConfirmationComponent,
        LoaderComponent,
        SelectDropdownRequiredValidatorDirective,
        DotsLoaderComponent,
        CurrencyFormatPipe,
        SearchComponent,
        ShowMoreComponent,
        MultiselectDropdownComponentComponent,
        SelectedGapsComponent,
        ProblemSolvingAttitudeComponent,
        GenerateReportComponent
    ],
    exports: [
        DropdownComponent,
       // BreadcrumbComponent, // Compoenent to be moved to shared after refactoring
        ValueHeaderComponent,
        SearchPipe,
        SortPipe,
        ValueFooterComponent,
        DeleteConfirmationComponent,
        LoaderComponent,
        SelectDropdownRequiredValidatorDirective,
        DotsLoaderComponent,
        CurrencyFormatPipe,
        SearchComponent,
        ShowMoreComponent,
        MultiselectDropdownComponentComponent,
        SelectedGapsComponent,
        ProblemSolvingAttitudeComponent

    ],
    providers: [
        CurrencyFormatPipe
    ],
    entryComponents: [
        DeleteConfirmationComponent,
        GenerateReportComponent
     ]

})

export class SharedModule {
    private static count = 0;
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/shared.module.ts